import { Constantes } from "../constants/constantsGlobal";
import { iResponse } from "../models/interfaceResponse";
import setupInterceptor from "./setupInterceptor";

   
export const chatbotMyDocs = async (user: any, setUser: (user: any) => void): Promise<iResponse> => {
  try { 
    const response = await setupInterceptor(Constantes.URI_ChatBotDatacenterMyDocs, user, setUser, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Error en la solicitud: ${response.statusText}`);
    }
    const data: iResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error al obtener datos:", error);
    throw error;
  }
};
